module.exports = __webpack_public_path__ + "static/media/team-on.15683f2d.svg";